<template>
  <div>
    <h1 class="mb-0">Reset Password</h1>
    <p>
      Enter your email address and we'll send you an email with instructions to
      reset your password.
    </p>
    <form class="mt-4" v-on:submit.prevent="fnForgotPassword">
      <div class="form-group">
        <label for="email">Email address</label>
        <input
          type="email"
          class="form-control mb-0"
          id="email"
          aria-describedby="emailHelp"
          placeholder="Enter email"
          v-model="user.email"
        />
      </div>

      <div class="d-inline-block w-100">
        <button type="submit" class="btn btn-primary float-right">
          Reset Password
        </button>
      </div>
    </form>
  </div>
</template>
<script>
import * as authService from '../../../services/auth.service'
import * as messageService from '../../../services/message.service'

export default {
  name: 'RecoverPassword',
  data() {
    return {
      user: {
        email: ''
      },
      errors: {}
    }
  },
  methods: {
    fnForgotPassword: async function () {
      try {
        const response = await authService.forgotPassword(this.user)
        this.errors = {}

        if (response.data.status_code === 200) {
          this.$router.push({ name: 'auth.recoverPasswordMessage' })
        }
      } catch (error) {
        switch (error.response.status) {
          case 401:
            this.errors = error.response.data.errors
            messageService.fnSweetAlertErrorToast(
              'Request new password',
              error.response.data.message
            )
            break
          case 422:
            this.errors = error.response.data.errors
            messageService.fnSweetAlertErrorToast(
              'Request new password',
              error.response.data.message
            )
            break
          case 500:
            messageService.fnSweetAlertErrorToast(
              'Request new password',
              error.response.data.message
            )
            break
          default:
            messageService.fnSweetAlertErrorToast(
              'Request new password',
              'Something wrong, please try again!'
            )
            break
        }
      }
    }
  }
}
</script>
